export default [
  {
    path: "/login",
    name: "Login",
    redirect: "/login/index",
    component: () => import("@/layouts/LoginLayouts.vue"),
    children: [
      {
        path: "/login/index",
        name: "login",
        component: () => import("@/views/login/index.vue"),
        meta: { title: "登录" },
      },
    ],
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/login/register.vue"),
    meta: { title: "注册" },
  },
  {
    path: "/user-protocol",
    name: "user-protocol",
    component: () => import("@/views/login/user-protocol.vue"),
    meta: { title: "用户协议" },
  },
  {
    path: "/table-result",
    name: "table-result",
    component: () => import("@/views/share-page/table-result/index.vue"),
    meta: { title: "表格结果数据" },
  },
  {
    path: "/weapp",
    name: "weapp",
    component: () => import("@/views/share-page/weapp/index.vue"),
    meta: {
      title: "使用小程序打开",
    },
  },
];
